module.exports = __webpack_public_path__ + "img/2_104.5be51bc7.png";